import React from 'react'
import naturalStoneMainBgImg from '../../../assets/img/banner-natural-stone/natural-stone-base-background.jpg'
import LocalizedLink from '../../global/LocalizedLink'
import Translation from '../../global/Translation'
import { getLanguageDir } from '../../../store/ui/reducers'
import { injectIntl } from 'react-intl'
import { connect } from 'react-redux'

const BannerShortCatalogNaturalStone = ({languageDir}) => {
    return (
        <div
            className="banner-short-catalog-natural-stone"
            style={{
                backgroundImage: `url(${naturalStoneMainBgImg})`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                backgroundPosition: '40% 50%',
                height: '100%',
                width: '100%'
            }}
        >
            <div className="banner-overlay"></div>
            <div className="banner-content">
                <div className="main-title">
                    <h2>
                        <Translation id="new_natural_stone_section" defaultMessage="New Natural Stone section" />
                    </h2>
                </div>
                <div className="text-content">
                    <p>
                        <Translation id="discover_our_selection_of_granite" defaultMessage="Discover our selection of granite, marble, and quartzite." />
                    </p>
                    <p>
                        <Translation id="access_the_latest_news_and_discover" defaultMessage="Access the latest news and discover the outlet at the best price." />
                    </p>
                </div>
                <div className="cta-button">
                    <LocalizedLink routeId="ROUTE_NATURAL_STONE" queryString="">
                        <button gtm-label="card_banner--product-list_got-to-natural-stone">
                            <Translation id="access" defaultMessage="Access" />
                            <i class={languageDir === 'rtl' ? "fa fa-long-arrow-left" : "fa fa-long-arrow-right"} aria-hidden="true" />
                        </button>
                    </LocalizedLink>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        languageDir: getLanguageDir(state)
    }
}

export default injectIntl(connect(mapStateToProps, null)(BannerShortCatalogNaturalStone))
